/** @module SiteAdmin/PasswordMinLengthController */
define([
	"dojo/_base/declare",
	"csi/heading/NumberController",
	"csi/locale"
], function(declare, NumberController, locale) {

	return declare(NumberController, {
		/**
		 * @override
		 * Make sure the min length less than or equal to the max length.
		 */
		onValidate() {
			var minLength = this.newValue;
			if (minLength < 5) {
				throw new Error(locale.resource("Validation_PasswordMinLength"));
			}

			var maxLength = this.getNode().PasswordMaxLength;
			if (minLength > maxLength) {
				throw new Error(locale.resource("Validation_PasswordLength"));
			}
		}
	});
});